import React from "react";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import Show from "@ui/Show";

import css from './RatingAndAddress.module.scss';

function RatingAndAddress({ rating, reviews, location1, location2 }: { rating: number; reviews?: number; location1?: string; location2?: string }) {
    const hasLocation = !!(location1 || location2);
    const hasRating = !!(rating || reviews);
    const location = [location1, location2].filter(Boolean).join(', ');
    const ratingLabel = ((reviews ?? 0) < 1 ) ? 'New' : `${rating.toFixed(1)}${reviews ? ` (${reviews})` : ''}`;
    return (
        <div className={`${css.container} d-flex gap-2 align-items-center`}>
            <Show when={hasRating}>
                <span className="d-flex gap-1 align-items-center text-nowrap"><Icon icon={faStar} width={16} height={16}/> {ratingLabel}</span>
            </Show>
            <Show when={hasRating && hasLocation}>
                <span className={css.delimiter}>·</span>
            </Show>
            <Show when={hasLocation}>
                <address className={css.address}>{location}</address>
            </Show>
        </div>
    );
    
}

export default RatingAndAddress;